import script from "./DuaLiked.vue?vue&type=script&setup=true&lang=js"
export * from "./DuaLiked.vue?vue&type=script&setup=true&lang=js"

import "./DuaLiked.vue?vue&type=style&index=0&id=04231aea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04231aea"]])

export default __exports__